import { render, staticRenderFns } from "./TituloDocumentoPadrao.vue?vue&type=template&id=5a74b68a&"
import script from "./TituloDocumentoPadrao.vue?vue&type=script&lang=js&"
export * from "./TituloDocumentoPadrao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports